import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import { Client } from '../../../api/api-reference';
import { FileService } from '../../../services/file.service';

@Component({
  selector: 'app-bulk-download',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './bulk-download.component.html',
  styleUrl: './bulk-download.component.scss',
})
export class BulkDownloadComponent implements OnInit {
  status: 'loading' | 'success' | 'error' = 'loading';
  errorMessage = '';
  path: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private client: Client,
    private fileService: FileService,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {}

  goToDashboard(): void {
    this.router.navigate(['/']);
  }

  ngOnInit(): void {
    this.path = this.route.snapshot.queryParamMap.get('path');
    if (!this.path) {
      this.status = 'error';
      this.errorMessage = this.translate.instant('BULK_DOWNLOAD_MISSING_PATH');
      return;
    }
    this.download();
  }

  download(): void {
    this.status = 'loading';
    this.client.downloadBulkFile(this.path!).subscribe({
      next: (response) => {
        const extension = response.data.type === 'application/zip' ? 'zip' : 'xlsx';
        this.fileService.downloadFile(response.data, response.fileName || `BulkExport.${extension}`);
        this.status = 'success';
      },
      error: () => {
        this.status = 'error';
        this.errorMessage = this.translate.instant('BULK_DOWNLOAD_EXPIRED');
      },
    });
  }
}
